import { useLocation, useHistory } from 'react-router-dom';
const YEAR_KEY = 'year';
const MODEL_KEY = 'model';
const useVehicleQueryParams = () => {
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const currentSelectedYear = queryParams.get(YEAR_KEY) || '';
    const currentSelectedModel = queryParams.get(MODEL_KEY) || '';
    const updateYearAndModel = (year, model) => {
        const searchParams = new URLSearchParams(location.search);
        if (year) {
            searchParams.set(YEAR_KEY, year);
        }
        else {
            searchParams.delete(YEAR_KEY);
        }
        if (model) {
            searchParams.set(MODEL_KEY, model);
        }
        else {
            searchParams.delete(MODEL_KEY);
        }
        history.replace({ search: searchParams.toString() });
    };
    return {
        currentSelectedYear,
        currentSelectedModel,
        updateYearAndModel,
    };
};
export default useVehicleQueryParams;
